let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2NQC0")).then(() => parcelRequire('7T3qi'));